export default "__VITE_ASSET__B1j0IlH1__"